import Vue from 'vue';
import throttle from 'lodash/throttle';

export function isElementInViewport(element) {
  const isInViewPort =
    element.getBoundingClientRect().top >= 0 &&
    element.getBoundingClientRect().left >= 0 &&
    element.getBoundingClientRect().right <=
      (window.innerWidth || document.documentElement.clientWidth) &&
    element.getBoundingClientRect().bottom <=
      (window.innerHeight || document.documentElement.clientHeight);
  return isInViewPort;
}

export const nativevideoLoad = {
  bind: (el, binding) => {
    const InjectVideo = throttle(() => {
      if (isElementInViewport(el)) {
        if (binding.value) {
          if (typeof el.firstElementChild.children === 'object') {
            for (const source in el.firstElementChild.children) {
              if (el.firstElementChild.children[source].tagName === 'SOURCE') {
                el.firstElementChild.children[source].src =
                  el.firstElementChild.children[source].dataset.src;
              }
            }
            el.firstElementChild.className = 'embed-responsive-item';
            el.firstElementChild.load();
          }
        }
        window.removeEventListener('scroll', InjectVideo);
      }
    }, 500);

    window.addEventListener('scroll', InjectVideo);

    // call immediately to check if currently in viewport
    Vue.nextTick(InjectVideo);
  },
};
